import { typesReembolsos } from '../types/typesReembolsos';

const initialState = {
  reembolsos: [],
  loading: false,
};

export const reembolsosReducer = (state = initialState, action) => {
  switch (action.type) {
    case typesReembolsos.storeReembolsos:
      return { ...state, reembolsos: action.payload };
    case typesReembolsos.setLoading:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};